module.exports = __webpack_public_path__ + "img/travel_with_pet.cabf51c0.png";